export default "__VITE_ASSET__89093b44__"